import React from 'react';
import styles from './RadioComponent.module.css';

const RadioComponent = ({ name, value, label, checked, onChange }) => {
  return (
    <label className={styles.radioLabel}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={styles.radioInput}
      />
      <span className={styles.customRadio}></span>
      <span className={styles.name}></span>
      <span className={styles.labelText}>{label}</span>
    </label>
  );
};

export default RadioComponent;
